import { FilterCategoriesDesktop } from 'src/features/filter-goods/ui/desktop-categories'
import { GoodsWithPagination } from 'src/widgets/pagination-goods/ui'
import React from 'react'
import * as S from './styled'
import DesktopFilter from '@shared/Filter/DesktopFilter'
import {
    $makersGoods,
    $outFormsGoods,
    useLengthMakers,
    useLengthOutForms,
    useSelectedMakers,
    useSelectedOutForms,
    useToggleMakers,
    useToggleOutForms
} from 'src/features/filter-goods/model/filter'
import { SortListDesktop } from 'src/features/filter-goods/ui/sort-list-desktop'

const FilterBlock = () => {
    return (
        <React.Fragment>
            <DesktopFilter
                filterStore={$outFormsGoods}
                title={'Формы выпуска'}
                useCheckSelected={useSelectedOutForms}
                useLength={useLengthOutForms}
                useToggleSelected={useToggleOutForms}
            />
            <DesktopFilter
                filterStore={$makersGoods}
                title={'Производитель'}
                useCheckSelected={useSelectedMakers}
                useLength={useLengthMakers}
                useToggleSelected={useToggleMakers}
            />
        </React.Fragment>
    )
}

export function GoodsFilters() {
    return (
        <S.Container>
            <S.LeftMenu>
                <FilterCategoriesDesktop />
                <FilterBlock />
            </S.LeftMenu>
            <S.RightBlock isLeftBlock>
                <SortListDesktop />
                <GoodsWithPagination />
            </S.RightBlock>
        </S.Container>
    )
}
export function GoodsFiltersWithoutCategories() {
    return (
        <S.Container>
            <S.LeftMenu>
                <FilterBlock />
            </S.LeftMenu>
            <S.RightBlock isLeftBlock>
                <GoodsWithPagination />
            </S.RightBlock>
        </S.Container>
    )
}
